export default __webpack_public_path__ + "static/media/yarden_truck_front.cb5636c6.jpg";